import styled, { css } from 'styled-components';
import {
    forTablet,
    forDesktop,
    forSemiWideScreens,
    forMidWideScreens,
    forWideScreens,
} from '@westwing/ui-kit/breakPoints';

export const TextWrapperPadding = styled.div<{ leftPadding: number; rightPadding: number }>`
    padding-left: ${({ leftPadding }) => `${leftPadding}px`};
    padding-right: ${({ rightPadding }) => `${rightPadding}px`};
    display: inline;
`;

export const pagePadding = css`
    ${forTablet`
        padding-left: ${({ theme }) => theme.tabletPagePadding};
        padding-right: ${({ theme }) => theme.tabletPagePadding};
    `}
    ${forDesktop`
        padding-left: ${({ theme }) => theme.desktopPagePadding};
        padding-right: ${({ theme }) => theme.desktopPagePadding};
    `}
`;

export const increasedPageWidthPadding = css`
    ${forSemiWideScreens`
            padding-left: ${({ theme }) => theme.desktopSemiWideScreensPadding};
            padding-right: ${({ theme }) => theme.desktopSemiWideScreensPadding};
      `}
    ${forWideScreens`
            padding-left: ${({ theme }) => theme.desktopWideScreensPadding};
            padding-right: ${({ theme }) => theme.desktopWideScreensPadding};
      `}
`;

export const midWideScreenPadding = css`
    ${forMidWideScreens`
            padding-left: ${({ theme }) => theme.desktopWideScreensPadding};
            padding-right: ${({ theme }) => theme.desktopWideScreensPadding};
    `}
`;

export const desktopPageWidthPadding = css`
    ${forTablet`
        padding-left: 15px;
        padding-right: 15px;
    `}
    ${forMidWideScreens`
        padding-left: 40px;
        padding-right: 40px;
    `}
`;

export default TextWrapperPadding;
